import React from "react";
import { Card, Col, Row, Space, Typography } from "antd";
import type { SpaceProps } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { radius } from "@libertify/ui";

interface ProjectSectionCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  iconTitle?: React.ReactNode;
  itemSpacing?: SpaceProps["size"];
  style?: React.CSSProperties;
}

export const ProjectSectionCard: React.FC<ProjectSectionCardProps> = ({
  title,
  subtitle,
  children,
  iconTitle,
  itemSpacing = 12,
  style,
}) => {
  const { theme, isMobile } = useAntTheme();

  return (
    <Card
      style={{
        backgroundColor: theme.colorCardRedesign,
        boxShadow: theme.cardBoxShadow,
        border: theme.cardBorder,
        width: "100%",
        borderRadius: radius.box,
        ...style,
      }}
      styles={{
        body: { padding: isMobile ? 10 : 25 },
      }}
    >
      <Row gutter={16} align={"middle"}>
        {iconTitle && (
          <Col
            xs={2}
            style={{
              backgroundColor: theme.colorPrimary,
              borderRadius: "12px",
              maxWidth: "46px",
              height: "46px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {iconTitle}
          </Col>
        )}
        <Col>
          <Typography.Title
            style={{
              margin: iconTitle ? "0px" : "0 0 16px 0",
              fontSize: "24px",
              fontWeight: "500",
              color: theme.colorTextTitle,
            }}
          >
            {title}
          </Typography.Title>
        </Col>
      </Row>
      {subtitle && (
        <Row style={{ marginTop: -15, marginBottom: 15 }}>
            <Typography.Text italic type="secondary">{subtitle}</Typography.Text>
        </Row>
      )}
      <Space direction="vertical" size={itemSpacing} style={{ width: "100%" }}>
        {children}
      </Space>
    </Card>
  );
};
